import { useEffect } from "react";
import { Message } from "../types";

const useResizeMessage = (source: string) => {
  useEffect(() => {
    const handleResize = () => {
      const height = document.body.scrollHeight;
      const message: Message = { height, type: "resize", source };
      window.parent.postMessage(message, "*");
    };

    const observer = new ResizeObserver(handleResize);
    observer.observe(document.body);

    handleResize();

    return () => {
      observer.disconnect();
    };
  }, [source]);
};

export default useResizeMessage;
